import {ObjectMediaContainer} from '../../core/definitions/object-media-container';

/** One-based position of the selected media across all media types, or 0 when nothing is selected. */
export function selectedMediaPosition(mediaContainer?: ObjectMediaContainer): number {
  const mediaTypes = mediaContainer?.mediaTypes ?? [];
  const current = mediaContainer?.currentMediaType;
  const typeIndex = mediaTypes.indexOf(current);
  if (typeIndex < 0) {
    return 0;
  }
  const before = mediaTypes.slice(0, typeIndex).reduce((acc, mediaType) => acc + mediaType.mediaElements.length, 0);
  return before + current.currentMediaIndex + 1;
}
